import React from "react";

const NotFound = () => (
    <div className="container">
        <h1>Page not found</h1>
        <p>Please try navigating to the link again or if you believe this to be a bug, please report this on discord!</p>
    </div>
);

export { NotFound }